import API from "API";
import { SendOutlined } from "@ant-design/icons";
import { Button, Card, Input, Space, Typography, message } from "antd";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./chatbot.css";

const { Text, Title, Paragraph } = Typography;

export default function Chatbot() {
    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [chat, setChat] = useState([]);
    const [sessionId, setSessionId] = useState(null);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        document.title = "hoctot.ai - Chatbot";
    }, []);

    const onSend = () => {
        const question = input.trim();
        if (!question || loading) return;

        setChat((prev) => [...prev, { role: "user", text: question }]);
        setInput("");
        setLoading(true);

        API.post("rag/chat/", { message: question, session_id: sessionId })
            .then((res) => {
                const reply = res?.data?.reply || "No response.";
                if (res?.data?.session_id) {
                    setSessionId(res.data.session_id);
                }
                setChat((prev) => [...prev, { role: "bot", text: reply }]);
            })
            .catch((err) => {
                const detail = err?.response?.data?.detail;
                messageApi.error(detail || "Chat request failed.");
            })
            .finally(() => setLoading(false));
    };

    return (
        <>
            {contextHolder}
            <Card>
                <Space direction="vertical" style={{ width: "100%" }} size={16}>
                    <div>
                        <Title level={4} style={{ marginBottom: 4 }}>
                            Chatbot RAG
                        </Title>
                        <Text type="secondary">
                            Ask questions from uploaded documents.
                        </Text>
                    </div>
                    <div>
                        <Button
                            onClick={() => {
                                setChat([]);
                                setSessionId(null);
                            }}
                            disabled={loading}
                        >
                            New conversation
                        </Button>
                    </div>

                    <div
                        style={{
                            border: "1px solid #f0f0f0",
                            borderRadius: 8,
                            padding: 12,
                            minHeight: 360,
                            maxHeight: 520,
                            overflowY: "auto",
                            background: "#fff",
                        }}
                    >
                        {chat.length === 0 ? (
                            <Text type="secondary">No messages yet. Ask the first question.</Text>
                        ) : (
                            <Space direction="vertical" style={{ width: "100%" }} size={12}>
                                {chat.map((item, idx) => (
                                    <div
                                        key={idx}
                                        style={{
                                            display: "flex",
                                            justifyContent:
                                                item.role === "user" ? "flex-end" : "flex-start",
                                        }}
                                    >
                                        <Card
                                            size="small"
                                            style={{
                                                maxWidth: "80%",
                                                background:
                                                    item.role === "user" ? "#e6f4ff" : "#fafafa",
                                            }}
                                        >
                                            {item.role === "bot" ? (
                                                <div className="chatbot-markdown">
                                                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                                        {item.text}
                                                    </ReactMarkdown>
                                                </div>
                                            ) : (
                                                <Paragraph style={{ marginBottom: 8 }}>{item.text}</Paragraph>
                                            )}
                                        </Card>
                                    </div>
                                ))}
                            </Space>
                        )}
                    </div>

                    <Space.Compact style={{ width: "100%" }}>
                        <Input
                            placeholder="Type your question..."
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onPressEnter={onSend}
                            disabled={loading}
                        />
                        <Button
                            type="primary"
                            icon={<SendOutlined />}
                            onClick={onSend}
                            loading={loading}
                        >
                            Send
                        </Button>
                    </Space.Compact>
                </Space>
            </Card>
        </>
    );
}
